import React from 'react'
import {Route, Switch} from 'react-router-dom'
import {connect} from 'react-redux'

import {routes, siders} from '../router'
import {Redirect} from 'react-router'
import {URL_HOME, URL_LOGIN} from '../const'
import MyContent from "./MyContent";
import PlanExpireModal from "./base/PlanExpireModal";
import {userLogout, userUpdatePlan} from "../action/user";


@connect(
    (state) => ({
        role: state.user.info.role,
        plan: state.user.plan
    }),
    {userLogout, userUpdatePlan}
)
class SAMContent extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            modalOpen: false
        }
    }

    logout = () => {
        this.props.userLogout()
        this.props.history.replace({pathname: URL_LOGIN})
    }

    componentDidMount() {
        if(this.props.plan && this.props.plan.expired) {
           if (this.props.role !== 'admin') {
               this.setState({modalOpen: true})
           }
        }
    }

    onSubscriptionChanged = (isSubscribed = false, updatedTime=null) => {
        this.setState({
            modalOpen: !isSubscribed
        })
       this.props.userUpdatePlan(updatedTime)
    }

    render() {
        const siderKey = 'sider'
        const routeKey = 'route'
        const route = [
            ...siders.reduce((acc, route, index) => {
                if (!route.role.includes(this.props.role)) {
                    return acc
                }
                if (Object.prototype.hasOwnProperty.call(route, 'subMenu')) {
                    acc.push(
                        ...route.subMenu.map((menu, menuIndex) => {
                            if (!menu.role.includes(this.props.role)) {
                                return
                            }
                            return <Route key={siderKey + index + menuIndex} path={menu.key} children={menu.main}
                                          exact={menu.exact}/>
                        }, [])
                    )
                } else {
                    acc.push(<Route key={siderKey + index} path={route.key} children={route.main} exact={route.exact}/>)
                }
                return acc
            }, []),
            ...routes.map((route, index) => {
                if (!route.role.includes(this.props.role)) {
                    return
                }
                if (route.redirect) {
                    return (
                        <Route key={routeKey + index} path={route.path} exact={route.exact}>
                            <Redirect to={route.redirect}/>
                        </Route>
                    )
                }
                return <Route key={routeKey + index} path={route.path} exact={route.exact} children={route.main}/>
            })
        ]
        route.push(
            <Route key={'except'} path={URL_HOME + '*'}>
                <Redirect to={URL_HOME}/>
            </Route>
        )
        return (
            <MyContent>
                <PlanExpireModal open={this.state.modalOpen} logout={this.logout}
                                 onSubscriptionChanged={this.onSubscriptionChanged} />
                <Switch>{route}</Switch>
            </MyContent>
        )
    }
}

export default SAMContent
